import { render, staticRenderFns } from "./GroupRunsTable.vue?vue&type=template&id=2d525286&scoped=true"
import script from "./GroupRunsTable.vue?vue&type=script&lang=js"
export * from "./GroupRunsTable.vue?vue&type=script&lang=js"
import style0 from "./GroupRunsTable.vue?vue&type=style&index=0&id=2d525286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d525286",
  null
  
)

export default component.exports